import { Skeleton } from 'baseui/skeleton'
import { Notification, KIND } from 'baseui/notification';

export interface LoadingViewProps {
  children: any;
  error?: any;
  isLoading: boolean;
  isSucess: boolean;
  rows?: number;
}

export const LoadingView = (props: LoadingViewProps) => {

  if (props.error) {
    if (props.error.status === 401 || props.error.originalStatus === 401)
      return (
        <Notification kind={KIND.negative}>
          <b>Access was denied </b>
          <br />
          <br />{props.error.data?.message}
        </Notification>
      )
    if (props.error.status === 500 || props.error.originalStatus === 500)
      return (
        <Notification kind={KIND.negative}>
          <b>Internal error in backend</b>
          <br />
          <br />{props.error.data?.message}
        </Notification>
      )
    return (
      <Notification kind={KIND.negative}>
        There has been an error loading data
        <br />
        <br />{JSON.stringify(props.error)}
      </Notification>
    )
  }
  if (props.isLoading) {
    return (
      <Skeleton animation 
        rows={props.rows || 3}
        overrides={{
          Root: { style: { minWidth: '100px'}},
          Row: {
            style: {
              height: '20px',
              marginBottom: '15px',
            },
          },
        }}
      />
    )
  }
  //if (props.isSucess) {
    const c = props.children;
    return (
      <>{c}</>
    )
  //}
  
  /*return (
    <span>idle</span>
  )*/
}